import React, { useId, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

interface Props {
  value: string;
  onChange: (value: string) => void;
  onEnter?: () => void;
  label?: string;
  placeholder?: string;
  className?: string;
}

type SaveState = "NONE" | "HAS_CHANGES" | "SAVED";

function SmallTextArea(props: Props) {
  const { t } = useTranslation();
  const id = useId();
  const ref = useRef<HTMLTextAreaElement>(null);

  const [saveState, setSaveState] = useState<SaveState>("NONE");

  function handleEnter() {
    ref.current?.blur();

    setSaveState("SAVED");
    setTimeout(() => setSaveState("NONE"), 2000);

    props.onEnter?.();
  }

  function onKeyDown(e: React.KeyboardEvent<HTMLTextAreaElement>) {
    if (e.key === "Enter" && e.metaKey)
      handleEnter();
  }

  function onChange(e: React.ChangeEvent<HTMLTextAreaElement>) {
    setSaveState("HAS_CHANGES");
    props.onChange(e.currentTarget.value)
  }

  return (
    <div className={props.className}>
      <div className="relative flex flex-col">
        <label htmlFor={id} className="text-xs font-semibold text-gray-400 bg-white ml-2 -mb-2 mr-auto px-1 z-10 w-auto">
          {props.label}
        </label>
        <textarea ref={ref} id={id} className="py-1 px-2 w-full font-gilroy outline-none text-sm border-gray-400 border-2 rounded-md" rows={5} value={props.value} placeholder={props.placeholder} onKeyDown={onKeyDown} onChange={onChange} />
        {(props.onEnter && saveState === "HAS_CHANGES") &&
          <div className="flex items-center text-xs absolute right-2 top-4 w-12 justify-center border rounded shadow px-1 pt-px bg-blue opacity-80 text-white cursor-pointer" onClick={handleEnter}>
            {t("Save")}
          </div>
        }
        {(props.onEnter && saveState === "SAVED") &&
          <div className="flex items-center text-xs absolute right-2 top-4 w-12 justify-center border rounded shadow px-1 pt-px bg-green opacity-80 text-white cursor-pointer" onClick={handleEnter}>
            {t("Saved")}
          </div>
        }
      </div>
    </div>
  );
};

export default SmallTextArea;
